// ABOUTME: React context feeding the prototype compatibility matrix cell renderer with state and handlers.
// ABOUTME: The matrix component provides it; GridCellCompatibilityRender consumes it to draw each cell.

import { createContext, ReactNode, useContext } from 'react';

export type CompatibilityCellState = 'full' | 'partial' | 'define';

export type CompatibilityMatrixCellContextValue = {
    /** Resolve the compatibility state between the row prototype and the column prototype. */
    getCellState: (rowPrototypeId: string, colPrototypeId: string) => CompatibilityCellState;
    /** Toggle Full <-> Define for the given pair (staged locally). */
    onToggle: (rowPrototypeId: string, colPrototypeId: string) => void;
    /** Open the partial (GL) configuration dialog for the given pair. */
    onEditPencil: (rowPrototypeId: string, colPrototypeId: string) => void;
    /** Maps a column content-type code (prototype code) to the prototype node id. */
    colCodeToId: Record<string, string>;
    /** When true, cells are read-only (e.g. the starting prototype is closed). */
    readOnly: boolean;
};

const CompatibilityMatrixCellContext = createContext<CompatibilityMatrixCellContextValue | null>(
    null,
);

export const CompatibilityMatrixCellProvider = ({
    value,
    children,
}: {
    value: CompatibilityMatrixCellContextValue;
    children: ReactNode;
}) => (
    <CompatibilityMatrixCellContext.Provider value={value}>
        {children}
    </CompatibilityMatrixCellContext.Provider>
);

export const useCompatibilityMatrixCell = () => useContext(CompatibilityMatrixCellContext);
